import { fromJS  } from 'immutable';

export const State = fromJS({
  isPutting: false,
  isPosting: false,
  isGetting: false,
  isDeleting: false,
  errMsg: ''
});